import { Hidden, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import * as React from "react";
import { RenderWhile } from "../../components/render-while";

var styles = function styles(theme) {
  var _a;

  return {
    root: {
      margin: "auto"
    },
    drawerBackdrop: {},
    header: {},
    content: {},
    backdrop: {
      backgroundColor: "transparant"
    },
    text: {
      fontFamily: "CircularStd",
      color: "#4D4D4F",
      fontWeight: 400,
      fontSize: "19px"
    },
    title: (_a = {
      color: "#FC2F2B",
      marginBottom: 20,
      lineHeight: 0.9,
      fontWeight: 700,
      fontSize: 70,
      fontFamily: "CircularStd"
    }, _a[theme.breakpoints.down("sm")] = {
      fontSize: "2.6em"
    }, _a),
    subtitle: {
      fontFamily: "CircularStd",
      fontSize: "30px",
      fontWeight: 700,
      margin: "20px 0",
      color: "#29B9B3"
    },
    description: {
      paddingRight: theme.spacing(1)
    },
    collapseContainer: {
      marginBottom: theme.spacing(3),
      position: "relative",
      "&:after": {
        content: "''",
        display: "block",
        position: "absolute",
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        boxShadow: "inset 0px -70px 40px -40px rgba(255,255,255,1)"
      },
      "&.MuiCollapse-entered": {
        "&:after": {
          boxShadow: "none"
        }
      }
    },
    contentPiece: {
      fontFamily: "Montserrat"
    },
    marginBottom: {
      marginBottom: "1em"
    }
  };
};

var Info = function Info(_a) {
  var edition = _a.edition,
      classes = _a.classes;
  var description = edition && edition.description && JSON.parse(edition.description) || "";
  return React.createElement(React.Fragment, null, React.createElement(Typography, {
    variant: "h1",
    className: classes.title
  }, "Inhoud"), React.createElement(Typography, {
    className: classes.subtitle
  }, "Terugblik op 2021"), React.createElement(Hidden, {
    mdDown: true
  }, React.createElement(Typography, {
    className: classes.text,
    paragraph: true
  }, "Welkom. Leuk dat je tijd hebt genomen om terug te blikken met ons over de afgelopen periode. Het is goed om stil te staan bij wat we in deze bewogen periode wel met elkaar hebben kunnen bereiken!"), React.createElement(Typography, {
    className: classes.text,
    paragraph: true
  }, "Hiernaast vind je het menu. Er zijn 10 hoofdstukken. Vanuit elk hoofdstuk kun je terug naar Home (linksonder \u2018Medisch Spectrum Twente\u2019) Linksonder kun je ook steeds terug naar de inhoudsopgave. Met de pijltjes navigeer je naar een volgend hoofdstuk. Sommige hoofdstukken zijn wat uitgebreider. Met de bolletjes aan de rechterzijde navigeer je naar een volgend onderwerp binnen het hoofdstuk."), React.createElement(Typography, {
    className: classes.text
  }, "Wij wensen je veel kijk- en leesplezier!")), React.createElement(Hidden, {
    mdUp: true
  }, React.createElement(Typography, {
    className: classes.text,
    paragraph: true
  }, "Mobiele welkom. Leuk dat je tijd hebt genomen om terug te blikken met ons over de afgelopen periode. Het is goed om stil te staan bij wat we in deze bewogen periode wel met elkaar hebben kunnen bereiken!"), React.createElement(Typography, {
    className: classes.text,
    paragraph: true
  }, "Hiernaast vind je het menu. Er zijn 10 hoofdstukken. Vanuit elk hoofdstuk kun je terug naar Home (linksonder \u2018Medisch Spectrum Twente\u2019) Linksonder kun je ook steeds terug naar de inhoudsopgave. Met de pijltjes navigeer je naar een volgend hoofdstuk. Sommige hoofdstukken zijn wat uitgebreider. Met de bolletjes aan de rechterzijde navigeer je naar een volgend onderwerp binnen het hoofdstuk."), React.createElement(Typography, {
    className: classes.text
  }, "Wij wensen je veel kijk- en leesplezier!")));
};

var EditionIndexThorax2022Component = function EditionIndexThorax2022Component(_a) {
  var edition = _a.edition,
      classes = _a.classes;

  var _b = React.useState(false),
      open = _b[0],
      setOpen = _b[1];

  return React.createElement(React.Fragment, null, React.createElement("div", null, React.createElement(RenderWhile, {
    desktop: true,
    print: true
  }, React.createElement(Info, {
    edition: edition,
    classes: classes
  }))));
};

export var EditionIndexThorax2022 = withStyles(styles)(EditionIndexThorax2022Component);